// eslint-disable-next-line
export const EXTERNAL_LINKS = {
  SAFE_DEAL_TERMS:
    'https://pomoc.olx.pl/hc/pl/articles/360016316399-Załącznik-nr-8-Pakiet-Ochronny-OLX',
  SAFE_DEAL_EXTENDED_TERMS:
    'https://pomoc.olx.pl/olxplhelp/s/article/za%C5%82%C4%85cznik-nr-8-pakiet-ochronny-olx-V20-olx ',
};
